import { render, staticRenderFns } from "./KanbanTaskLaneItem.vue?vue&type=template&id=804b4754&scoped=true"
import script from "./KanbanTaskLaneItem.vue?vue&type=script&lang=js"
export * from "./KanbanTaskLaneItem.vue?vue&type=script&lang=js"
import style0 from "./KanbanTaskLaneItem.vue?vue&type=style&index=0&id=804b4754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b4754",
  null
  
)

export default component.exports